import { useRef, useEffect } from "react";
import { useReactToPrint } from "react-to-print";
import "./PdfConsentimentosStyle.scss";
import moment from "moment/moment";
import "moment/locale/pt";

moment.locale("pt");

const printStyles = `
  @media print {
    @page {
      size: A4;
      margin: 20mm;
    }
  }
`;

const CONSENTIMENTO_LABELS = {
  sms_lembretes: "Receção de SMS com lembretes de consultas e tratamentos",
  email_lembretes: "Receção de emails com lembretes de consultas e tratamentos",
  email_promocional:
    "Receção de emails com informações promocionais e campanhas da clínica",
  sms_promocional:
    "Receção de SMS com informações promocionais e campanhas da clínica",
  partilha_documentos: "Receção de documentos clínicos e relatórios por email",
};

function PdfConsentimentos({ consentimentoData, showPreviousPage }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Consentimento-${consentimentoData.cliente.nome}_${moment().format("DD-MM-YYYY")}`,
    onAfterPrint: () => showPreviousPage(),
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    handlePrint();
  }, [handlePrint]);

  const { clinica, cliente, criadoPor, consentimentos } = consentimentoData;

  return (
    <div
      ref={componentRef}
      className={`pdf-wrapper ${clinica?.configuracoes?.configuracoes?.impressaoPretoEBranco?.ativo ? " pdf-wrapper--pretoebranco" : ""}`}
    >
      <style>{printStyles}</style>
      <div className="pdf-consentimento-body">
        {/* CABEÇALHO */}
        <div className="pdf-consentimento__cabecalho">
          <div className="pdf-consentimento__cabecalho--left">
            <img
              src={`${process.env.REACT_APP_BACKEND_LINK}/${clinica.logotipo}`}
              alt="logotipo"
            />
          </div>
          <div className="pdf-consentimento__cabecalho--right">
            <span className="pdf-consentimento__cabecalho--right--dark">
              {clinica.nome || ""}
            </span>
            <span className="pdf-consentimento__cabecalho--right--dark">
              {clinica.donoDaClinica}/{criadoPor.profissao}
            </span>
            <span>
              Tel:{clinica.contacto || ""}
              {clinica.contacto2 ? `/${clinica.contacto2}` : ""}
              {clinica.contacto3 ? `/${clinica.contacto3}` : ""}
            </span>
            <span>{clinica.endereco}</span>
            <span className="pdf-consentimento__cabecalho--right--dark">
              NIF: {clinica.nif}
            </span>
          </div>
        </div>

        {/* DIVISOR */}
        <div className="pdf-consentimento__divisor" />

        {/* TÍTULO */}
        <div className="pdf-consentimento__titulo-container">
          <h2 className="pdf-consentimento__titulo">
            Declaração de Consentimento para Comunicações
          </h2>
          <p className="pdf-consentimento__subtitulo">
            (Regulamento Geral de Proteção de Dados – RGPD)
          </p>
        </div>

        {/* CORPO */}
        <div className="pdf-consentimento__corpo">
          <p className="pdf-consentimento__paragrafo">
            Eu, <span className="pdf-consentimento--dark">{cliente.nome}</span>,
            paciente da clínica{" "}
            <span className="pdf-consentimento--dark">{clinica.nome}</span>,
            declaro, de forma livre, específica, informada e inequívoca, que
            consinto no tratamento dos meus dados pessoais para os seguintes
            fins de comunicação:
          </p>

          {/* LISTA DE CONSENTIMENTOS */}
          <div className="pdf-consentimento__lista">
            {consentimentos.map((chave) => (
              <div key={chave} className="pdf-consentimento__lista__item">
                <input
                  type="checkbox"
                  className="pdf-consentimento__lista__item__checkbox"
                  defaultChecked
                  readOnly
                />
                <span className="pdf-consentimento__lista__item__texto">
                  {CONSENTIMENTO_LABELS[chave] || chave}
                </span>
              </div>
            ))}
          </div>

          <p className="pdf-consentimento__paragrafo">
            Declaro ter sido informado(a) de que os meus dados pessoais serão
            tratados de forma confidencial, utilizados exclusivamente para os
            fins acima indicados e não serão partilhados com terceiros sem o meu
            consentimento prévio.
          </p>

          <p className="pdf-consentimento__paragrafo">
            Tenho conhecimento de que posso revogar este consentimento a
            qualquer momento, sem qualquer prejuízo para o meu tratamento
            odontológico, mediante comunicação escrita ou verbal dirigida à
            clínica.
          </p>
        </div>

        {/* ASSINATURA */}
        <div className="pdf-consentimento__assinatura-section">
          <div className="pdf-consentimento__assinatura-local-data">
            <span>
              {clinica.ilha}, {moment().format("D [de] MMMM [de] YYYY")}
            </span>
          </div>

          <div className="pdf-consentimento__assinatura-bloco">
            <p className="pdf-consentimento__assinatura-nome">
              Eu,{" "}
              <span className="pdf-consentimento--dark">{cliente.nome}</span>,
              declaro ter lido e compreendido o presente documento e consinto
              com as comunicações acima selecionadas.
            </p>
            <div className="pdf-consentimento__assinatura-linha-container">
              <span className="pdf-consentimento__assinatura-linha">
                _______________________________________________
              </span>
              <span className="pdf-consentimento__assinatura-label">
                Assinatura do Paciente
              </span>
            </div>
          </div>
        </div>

        {/* RODAPÉ */}
        <div className="pdf-consentimento__rodape">
          <span>
            Processado por{" "}
            <span className="pdf-consentimento--dark">HEALTH TECH CV</span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default PdfConsentimentos;
